







































import SourceSelectInput from '@/components/source-select-input.vue'
import { StreamRepository } from '@/core/api/streams'
import Vue from 'vue'

export default Vue.extend({
  components: {
    SourceSelectInput,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: (): [] => [],
    },
  },
  data: () => ({
    dialog: false,
    streams: [],
    update: {
      source: {} as any,
      streams: [],
    },
  }),
  watch: {
    show(newVal) {
      this.reset()
      new StreamRepository().$getPage(1, { 'page_size': 1000 }).then(response => {
        this.streams = response.results
      })
      this.dialog = newVal
    },
  },
  methods: {
    reset() {
      this.update = {
        source: {},
        streams: [],
      }
    },
    close() {
      this.$emit('update:show', false)
    },
    submit() {
      this.$emit('submit', { source: this.update.source.id, streams: this.update.streams })
      this.close()
    },
  },
})
